"use client";

import { ChartCard } from "@/components/ui/chart-card";
import { BarChartSkeleton } from "@/components/ui/chart-skeletons";

export default function CompetitiveIntensitySkeleton() {
  return (
    <ChartCard 
      title="Competitive Intensity by Revenue Bracket"
      subtitle="Number of competing apps grouped by revenue brackets, indicating market density"
    >
      <div className="-mx-2">
        <BarChartSkeleton 
          barCount={6} 
          heights={[35, 55, 75, 45, 65, 50]} 
          className="h-64" 
        />
      </div>
    </ChartCard>
  );
}
